import React from "react";
import { Route, Navigate } from "react-router-dom";
import Protected from "../components/Protected";
import AdminProtected from "../components/AdminProtected";
// import CourseListing from "../pages/Admin-pages/TnAdminCoursePages/CourseListing";
import ClientAdminProtected from "../components/ClinetAdminProtected";
import CourseListingCA from "../pages/Admin-pages/CAAdminCoursePages/CourseListingCA";
import CourseAdd from "../pages/Admin-pages/CAAdminCoursePages/CourseAdd";
import CourseEdit from "../pages/Admin-pages/CAAdminCoursePages/CourseEdit";
// import CatAndSubCat from "../pages/Admin-pages/CAAdminCoursePages/CatAndSubCat";
import LearningRecords from "../pages/Admin-pages/CAAdminCoursePages/LearningRecords";
// import CatAndSubCat2 from "../pages/Admin-pages/CAAdminCoursePages/CatAndSubCat2";
import CatAndSSubCatTesting from "../pages/Admin-pages/CA-admin-pages/CatAndSSubCatTesting";
import LearningRecordsAdd from "../pages/Admin-pages/CAAdminCoursePages/LearningRecordsAdd";
import CourseLearningPlan from "../pages/Admin-pages/CAAdminCoursePages/Records/CourseLearningPlan";
import Producers from "../pages/Admin-pages/CAAdminCoursePages/Producers";
import BundleListingCA from "../pages/Admin-pages/CAAdminCoursePages/BundleListingCA";
import BundleAdd from "../pages/Admin-pages/CAAdminCoursePages/BundleTabs/BundleAdd";
import BundleEdit from "../pages/Admin-pages/CAAdminCoursePages/BundleTabs/BundleEdit";
import LearningRecordsEdit from "../pages/Admin-pages/CAAdminCoursePages/LearningRecordsEdit";
import CoursePreview from "../pages/Admin-pages/CAAdminCoursePages/CourseEditTabs/CoursePreview";
import WorkRoles from "../pages/Admin-pages/CAAdminCoursePages/Records/WorkRoles";
import CourseRoles from "../pages/Admin-pages/CAAdminCoursePages/Records/CourseRoles";
import LearnerMatrix from "../pages/Admin-pages/CAAdminCoursePages/Records/LearnerMatrix";
import CourseQuizListing from "../pages/Admin-pages/TnAdminCoursePages/CourseQuizListing";
import CourseQuizAdd from "../pages/Admin-pages/TnAdminCoursePages/CourseQuizAdd";
import LearningPathCA from "../pages/Admin-pages/CAAdminCoursePages/LearningPathCA";
import PathAdd from "../pages/Admin-pages/CAAdminCoursePages/LearningPathTabs/PathAdd";
import PathEdit from "../pages/Admin-pages/CAAdminCoursePages/LearningPathTabs/PathEdit";

const TraineryLearnRoutes = () => {
  const routes = [
    <Route
      key="trainery-l-1"
      path="/trainery-learn/courses/listing"
      element={
        <Protected>
          <AdminProtected>
            <CourseListingCA />
          </AdminProtected>
        </Protected>
      }
    />,

    <Route
      path="/trainery-learn/courses"
      element={<Navigate to={"/trainery-learn/courses/listing"} />}
    />,
    <Route
      key="trainery-l-14343"
      path="/trainery-learn/quiz/listing"
      element={
        <Protected>
          <AdminProtected>
            <CourseQuizListing />
          </AdminProtected>
        </Protected>
      }
    />,

    <Route
      path="/trainery-learn/quiz"
      element={<Navigate to={"/trainery-learn/quiz/listing"} />}
    />,
    <Route
      key="trainery-l-1434323"
      path="/trainery-learn/quiz/add"
      element={
        <Protected>
          <AdminProtected>
            <CourseQuizAdd />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-rbc-ewe32s"
      path="/trainery-learn/courses/preview/:id"
      element={
        <Protected>
          <AdminProtected>
            <CoursePreview />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-rbc-0987854875"
      path="/trainery-learn/courses/add"
      element={
        <Protected>
          <AdminProtected access={true}>
            <CourseAdd />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-rbc-0984432865iui6"
      path="/trainery-learn/courses/edit/:id"
      element={
        <Protected>
          <AdminProtected access={true}>
            <CourseEdit />
          </AdminProtected>
        </Protected>
      }
    />,

    <Route
      key="trainery-l-1-t224343"
      path="/trainery-learn/topics/categories"
      element={
        <Protected>
          <AdminProtected access={true}>
            <CatAndSSubCatTesting />
          </AdminProtected>
        </Protected>
      }
    />,

    <Route
      path="/trainery-learn/topics"
      element={<Navigate to={"/trainery-learn/topics/categories"} />}
    />,

    <Route
      key="trainery-l-1-t23224343"
      path="/trainery-learn/producers/listing"
      element={
        <Protected>
          <AdminProtected access={true}>
            <Producers />
          </AdminProtected>
        </Protected>
      }
    />,

    <Route
      path="/trainery-learn/producers"
      element={<Navigate to={"/trainery-learn/producers/listing"} />}
    />,
    // tnadmin route ends here

    <Route
      key="ca-route-log-0134new22ss"
      path="/ca-admin/trainery-learn/courses/listing"
      element={
        <Protected>
          <ClientAdminProtected access={true}>
            <CourseListingCA />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      path="/ca-admin/trainery-learn/courses"
      element={<Navigate to={"/ca-admin/trainery-learn/courses/listing"} />}
    />,

    <Route
      key="ca-rbc-098"
      path="/ca-admin/trainery-learn/courses/add"
      element={
        <Protected>
          <ClientAdminProtected access={true}>
            <CourseAdd />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-rbc-0984432"
      path="/ca-admin/trainery-learn/courses/edit/:id"
      element={
        <Protected>
          <ClientAdminProtected access={true}>
            <CourseEdit />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="trainery-l-1-t22"
      path="/ca-admin/trainery-learn/topics/categories"
      element={
        <Protected>
          <ClientAdminProtected access={true}>
            <CatAndSSubCatTesting />
          </ClientAdminProtected>
        </Protected>
      }
    />,

    <Route
      path="/ca-admin/trainery-learn/topics"
      element={<Navigate to={"/ca-admin/trainery-learn/topics/categories"} />}
    />,

    <Route
      key="trainery-l-1-t2243a"
      path="/ca-admin/trainery-learn/records/listing"
      element={
        <Protected>
          <ClientAdminProtected access={true}>
            <LearningRecords />
          </ClientAdminProtected>
        </Protected>
      }
    />,

    <Route
      path="/ca-admin/trainery-learn/records"
      element={<Navigate to={"/ca-admin/trainery-learn/records/listing"} />}
    />,

    <Route
      key="trainery-l-1-t22434334"
      path="/ca-admin/trainery-learn/records/add"
      element={
        <Protected>
          <ClientAdminProtected access={true}>
            <LearningRecordsAdd />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="trainery-l-1-t322243434334"
      path="/ca-admin/trainery-learn/records/edit/:id"
      element={
        <Protected>
          <ClientAdminProtected access={true}>
            <LearningRecordsEdit />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="trainery-334l-1-t2243a"
      path="/ca-admin/trainery-learn/learning-matrix/work-roles"
      element={
        <Protected>
          <ClientAdminProtected access={true}>
            <WorkRoles />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      path="/ca-admin/trainery-learn/learning-matrix"
      element={
        <Navigate to={"/ca-admin/trainery-learn/learning-matrix/work-roles"} />
      }
    />,
    <Route
      key="trainery-334l23-1-t2243a"
      path="/ca-admin/trainery-learn/learning-matrix/course-roles"
      element={
        <Protected>
          <ClientAdminProtected access={true}>
            <CourseRoles />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="trainery-334asl23-1-t2243a"
      path="/ca-admin/trainery-learn/learning-matrix/learner-roles"
      element={
        <Protected>
          <ClientAdminProtected access={true}>
            <LearnerMatrix />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="trainery-l-1-t22434334989898"
      path="/ca-admin/trainery-learn/learning-matrix/course-learners"
      element={
        <Protected>
          <ClientAdminProtected access={true}>
            <CourseLearningPlan />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      path="/ca-admin/trainery-learn/bundles"
      element={<Navigate to={"/ca-admin/trainery-learn/bundles/listing"} />}
    />,

    <Route
      key="trainery-l-1-4343ds4334"
      path="/ca-admin/trainery-learn/bundles/listing"
      element={
        <Protected>
          <ClientAdminProtected access={true}>
            <BundleListingCA />
          </ClientAdminProtected>
        </Protected>
      }
    />,

    <Route
      key="ca-rbc-098re443"
      path="/ca-admin/trainery-learn/bundles/add"
      element={
        <Protected>
          <ClientAdminProtected access={true}>
            <BundleAdd />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-rbc-ewe32s"
      path="/ca-admin/trainery-learn/bundles/edit/:id"
      element={
        <Protected>
          <ClientAdminProtected access={true}>
            <BundleEdit />
          </ClientAdminProtected>
        </Protected>
      }
    />,

    <Route
      key="ca-rbc-ewe32s32"
      path="/ca-admin/trainery-learn/courses/preview/:id"
      element={
        <Protected>
          <ClientAdminProtected access={true}>
            <CoursePreview />
          </ClientAdminProtected>
        </Protected>
      }
    />,

    <Route
      key="ca-rbc545-ewe32s32"
      path="/ca-admin/trainery-learn/learning-path"
      element={
        <Protected>
          <ClientAdminProtected access={true}>
            <LearningPathCA />
          </ClientAdminProtected>
        </Protected>
      }
    />,

    <Route
      key="ca-rbc545-ewe32s433432"
      path="/ca-admin/trainery-learn/learning-path/add"
      element={
        <Protected>
          <ClientAdminProtected access={true}>
            <PathAdd />
          </ClientAdminProtected>
        </Protected>
      }
    />,
    <Route
      key="ca-rbc545-ewe3432s433432"
      path="/ca-admin/trainery-learn/learning-path/edit/:id"
      element={
        <Protected>
          <ClientAdminProtected access={true}>
            <PathEdit />
          </ClientAdminProtected>
        </Protected>
      }
    />,
  ];
  return routes;
};
export default TraineryLearnRoutes;
